import { render, staticRenderFns } from "./studentAddAfterSales.vue?vue&type=template&id=1420ad45&scoped=true&"
import script from "./studentAddAfterSales.vue?vue&type=script&lang=js&"
export * from "./studentAddAfterSales.vue?vue&type=script&lang=js&"
import style0 from "./studentAddAfterSales.vue?vue&type=style&index=0&id=1420ad45&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1420ad45",
  null
  
)

export default component.exports